import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { toast } from "react-toastify";
import api from "../../../api/api";
import { QUERY_ADMIN_DASHBOARD_TEAM_SETTINGS_KEY } from "../../../api/queryKeys";
import {
  QueryStandardSuccessResponse,
  MutationAdminInviteNewTeamMemberRequestBody,
} from "../../../types";
import { ADMIN_TEAM_INVITE } from "../../../api/queryKeys";

const inviteTeamMember = (data: MutationAdminInviteNewTeamMemberRequestBody) =>
  api.post(ADMIN_TEAM_INVITE, data).then((res) => res.data);

export default function useInviteNewTeamMember({
  onSuccessHandler,
}: {
  onSuccessHandler?: () => void;
}) {
  const queryClient = useQueryClient();
  return useMutation<
    QueryStandardSuccessResponse,
    AxiosError,
    MutationAdminInviteNewTeamMemberRequestBody
  >(inviteTeamMember, {
    onSuccess: (data) => {
      queryClient.refetchQueries([QUERY_ADMIN_DASHBOARD_TEAM_SETTINGS_KEY]);
      toast.success("Invite sent");

      if (onSuccessHandler) {
        onSuccessHandler();
      }
    },
    onError: (error) => {
      toast.error("Error sending invite");
    },
  });
}
